import { Component, ComponentRef, Type, ViewChild, ViewContainerRef, effect, signal, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Trucker } from '@app/common-codes/models/matwins-tenant/Trucker.model';
import { TruckerDetailComponent } from '../trucker-detail/trucker-detail.component';
import { LookupProfile, LookupService, LookupItem } from '@app/common-codes/services/LookupService';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';

@Register(Trucker)
@Component({
  selector: 'app-trucker-list',
  templateUrl: './trucker-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ListViewComponent,
    TruckerDetailComponent,
    ListTableColumnComponent,
    TranslatePipe,
    ReactiveBadgeComponent
  ]
})
export class TruckerListComponent extends GenericListComponent<Trucker> {
  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = Trucker;
  override entityMetaData: IEntityMetaData = new Trucker().GetType();
  private loadedComponents: { [key: string]: ComponentRef<any> } = {};
  override contextMenuItems = [];
  // isModalOpen = signal(false);
  modalEntity = signal<Trucker | null>(null);
  @ViewChild('truckerDetail', { read: TruckerDetailComponent }) truckerDetail!: TruckerDetailComponent;
  truckerStatusLookup = signal<LookupItem[]>([]);
  truckerValidationStateLookup = signal<LookupItem[]>([]);


  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      {
        lookupName: "PointOfService"
      },
      {
        lookupName: "TruckerStatus"
      },
      {
        lookupName: "TruckerValidationState"
      },
    ];
    return lookupProfiles;
  }
  constructor(private tabLoader: TabComponentLoader, _alertModalService: AlertModalService, translationService: TranslationService) {
    super();
    this.alertModalService = _alertModalService;

    effect(() => {
      const entities = this.listView()?.entities();
      if (entities) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.truckerStatusLookup.set(this.lookupService.getLookupData('TruckerStatus'));
        this.truckerValidationStateLookup.set(this.lookupService.getLookupData('TruckerValidationState'));
      }
    });
  }


  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    this.listView()?.onSearch(value);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override getdetailComponent(): GenetricDetailComponent<Trucker> | undefined {
    return this.truckerDetail;
  }

  // override editSelectedItem(selectedItem: Trucker) {
  //   this.selectedItem.set(selectedItem);
  //   this.isModalOpen.set(true);
  // }

  // override openCreateModal() {
  //   var emptyEntity = this.getdetailComponent()?.getEmptyEntity();
  //   this.selectedItem.set(emptyEntity || null);
  //   this.getdetailComponent()?.editingEntity.set(emptyEntity || null);

  //   this.isModalOpen.set(true);
  // }

  // closeModal() {
  //   this.isModalOpen.set(false);
  //   this.selectedItem.set(null);
  //   // this.refreshList();
  // }

}
